import client from './client'
const airTableApp = 'appnrEYYuGOh8qFRN'
const baseUrl = `https://api.airtable.com/v0/${airTableApp}/`

var mapResult = function(result) {
    return result.records.map((item)=>{
        return {
            id: item.id,
            offset: result.offset||0,
            ...item.fields
        }
    })
}

export async function go ({code, settings}) {
    const response = await client({
        method: 'POST',
        url: baseUrl + '/run',
        data: {
            code,
            settings
        }
    })
    return response.data
}

export async function getCoordinates (place) {
    const token = 'pk.eyJ1IjoiZHFpYTAwMDEiLCJhIjoiY2p0cGpoM3pkMDVhaDN5cXN1aTN0eDI5byJ9.tCL6OxJKJeGo6jJ2LKulyw'
    const response = await client({
        method: 'GET',
        url: `https://api.mapbox.com/geocoding/v5/mapbox.places/${place}.json?access_token=${token}`,
    })
    return response.data
}

export async function run (id) {
    const response = await client({
        method: 'GET',
        url: baseUrl + '/run/' + id,
    })
    return response.data
}

const ThingAdapter = {
    async getOne(id, token) {
        const response = await client({
            method: 'GET',
            token: token,
            url: baseUrl + '/resource/' + id
        })
        return mapResult(response.data)
    },
    async getMany(id, token) {
        const response = await client({
            method: 'GET',
            token: token,
            url: baseUrl + '/resource/' + id
        })
        return mapResult(response.data)
    },
    async findOne(id, token) {
        const response = await client({
            method: 'GET',
            token: token,
            url: baseUrl + '/resource/' + id
        })
        return mapResult(response.data)
    },
    async create (item) {
        const response = await client({
            method: 'POST',
            url: baseUrl + '/resource/',
            data: {
                ...item
            }
        })
        return response.data
    },
    async update (item) {
        const response = await client({
            method: 'PUT',
            url: baseUrl + '/resource/' + item.id,
            data: {
                ...item
            }
        })
        return response.data
    },
    async delete (id) {
        const response = await client({
            method: 'DELETE',
            url: baseUrl + '/resource/' + id,
        })
        return response.data
    }
}

console.log(ThingAdapter)

/* articles */
export async function getArticles () {
    const response = await client({
        method: 'GET',
        url: baseUrl + 'Article'
    })
    return mapResult(response.data)
}

export async function saveArticle (item) {
    const response = await client({
        method: 'POST',
        url: baseUrl + 'Article',
        data: {
            ...item
        }
    })
    return response.data
}

export async function getArticle (id, token) {
    const response = await client({
        method: 'GET',
        token: token,
        url: baseUrl + 'Article/' + id
    })
    return mapResult(response.data)
}

export async function updateArticle (item, id) {
    const response = await client({
        method: 'PUT',
        url: baseUrl + 'Article/' + id,
        data: {
            ...item
        }
    })
    return response.data
}

export async function deleteArticle (id) {
    const response = await client({
        method: 'DELETE',
        url: baseUrl + 'Article/' + id
    })
    return response.data
}

/* resources */
export async function getResources (offset = 0) {
    const response = await client({
        method: 'GET',
        url: baseUrl + 'Resource?sort%5B0%5D%5Bfield%5D=DateCreated&sort%5B0%5D%5Bdirection%5D=desc&offset=' + offset
    })
    return mapResult(response.data)
}

function objectToFilterByFormula(obj) {
    // remove null keys
    Object.keys(obj).forEach((k) => obj[k] == null && delete obj[k]);
    let keys = Object.keys(obj)
    let hasValue = Object.values(obj).some(v=>v)
    let hasMultitple = keys.length > 1 && hasValue

    if (hasValue) {
        let filter = hasMultitple ? 'AND(' : '' 
        keys.forEach((k,i)=>{
            if (obj[k]) {
                // filter = filter + `{${k}}='${obj[k]}'`
                filter = filter + `SEARCH(LOWER('${obj[k]}'),LOWER({${k}}))`
                if (i < keys.length-1 ) {
                    filter = filter + ','
                }
            }
        })
        filter = filter + (hasMultitple ? ')' : '')
        console.log(filter)
        return encodeURIComponent(filter)
    }
    return ''
}

export async function getResourceView (view, pageSize = 100, offset = 0, filter = {}) {
    const filterStr = objectToFilterByFormula(filter)
    const response = await client({
        method: 'GET',
        url: baseUrl + `Resource?pageSize=${pageSize}&offset=${offset}&view=${view}&filterByFormula=${filterStr}`
    })
    let result = mapResult(response.data)
    // load tags
    result.forEach((item) => {
        if (item.Tags) {
            item.TagNames = []
            item.Tags.forEach(async (tagId) => {
                // fetch
                const resp = await client({
                    method: 'GET',
                    url: baseUrl + `Tags/${tagId}`
                })
                // console.log(resp.data)
                item.TagNames.push(resp.data.fields.Name)
            })
        }
    })
    return result
}

export async function slicedResources (sortBy) {
    const response = await client({
        method: 'GET',
        url: baseUrl + 'Resource/sort/' + sortBy
    })
    return response.data
}

export async function searchResources (query) {
    const response = await client({
        method: 'GET',
        url: baseUrl + 'Resource/search?q=' + query
    })
    return response.data
}

export async function searchResourcesByTag (tag) {
    const response = await client({
        method: 'GET',
        url: baseUrl + 'Resource/tagged/' + tag
    })
    return response.data
}

export async function saveResource (ply) {
    const response = await client({
        method: 'POST',
        url: baseUrl + 'Resource',
        data: {
            ...ply
        }
    })
    return response.data
}

export async function getResource (id, token) {
    const response = await client({
        method: 'GET',
        token: token,
        url: baseUrl + '/resource/' + id
    })
    return mapResult(response.data)
}

export async function getResourceMeta (id) {
    const response = await client({
        method: 'GET',
        url: baseUrl + '/resource/meta/' + id
    })
    return mapResult(response.data)
}

export async function getResourceMoreImages (id, recId) {
    var baseUrl = 'http://localhost:8083'
    const response = await client({
        method: 'GET',
        url: baseUrl + '/api/moreimages/' + id + '/' + recId
    })
    return response.data
}

export async function loadResource (remoteId, type) {
    var baseUrl = 'http://localhost:8083'
    const response = await client({
        method: 'GET',
        url: baseUrl + '/api/abnb/' + remoteId
    })
    return response.data
}

export async function updateResource (ply) {
    if (ply.userId) {
        // don't overwrite user info
        delete ply.userId
    }
    const response = await client({
        method: 'PUT',
        url: baseUrl + '/resource/' + ply.objectId,
        data: {
            ...ply
        }
    })
    return response.data
}

export async function deleteResource (id) {
    const response = await client({
        method: 'DELETE',
        url: baseUrl + '/resource/' + id
    })
    return response.data
}

export async function voteResource (plyId, userId, token) {
    const response = await client({
        method: 'POST',
        url: baseUrl + '/resource/vote/' + plyId,
        data: {
            userId,
            token
        }
    })
    return response.data
}

export async function favoriteResource (plyId, userId, token) {
    const response = await client({
        method: 'POST',
        url: baseUrl + '/resource/favorite/' + plyId,
        data: {
            userId,
            token
        }
    })
    return response.data
}

/* categories */
export async function getCategories () {
    const response = await client({
        method: 'GET',
        url: baseUrl + 'Category'
    })
    return mapResult(response.data)
}

export async function saveCategory (cat) {
    const response = await client({
        method: 'POST',
        url: baseUrl + 'Category',
        data: {
            ...cat
        }
    })
    return response.data
}

export async function getCategory (id, token) {
    const response = await client({
        method: 'GET',
        token: token,
        url: baseUrl + 'Category/' + id
    })
    return response.data
}

export async function updateCategory (cat) {
    const response = await client({
        method: 'PUT',
        url: baseUrl + 'Category/' + cat.objectId,
        data: {
            ...cat
        }
    })
    return response.data
}

export async function deleteCategory (id) {
    const response = await client({
        method: 'DELETE',
        url: baseUrl + 'Category/' + id
    })
    return response.data
}

/* tags */
export async function getTags () {
    const response = await client({
        method: 'GET',
        url: baseUrl + 'Tags'
    })
    return response.data
}

/* users */
export async function getUsers () {
    const response = await client({
        method: 'GET',
        url: baseUrl + 'Users'
    })
    return response.data
}

export async function getUsersTop () {
    const response = await client({
        method: 'GET',
        url: baseUrl + 'Users/top'
    })
    return response.data
}

export async function getUsersSorted (sort) {
    const response = await client({
        method: 'GET',
        url: baseUrl + 'Users/' + sort + '/avatar'
    })
    return response.data
}

export async function getUser (id) {
    const response = await client({
        method: 'GET',
        url: baseUrl + '/user/' + id
    })
    return response.data
}

export async function findUser (username) {
    const response = await client({
        method: 'GET',
        url: baseUrl + '/user/find/' + username
    })
    return response.data
}

export async function getUserResources (userId) {
    const response = await client({
        method: 'GET',
        url: baseUrl + '/user/' + userId + '/resources'
    })
    return response.data
}

export async function getUserFavorites (userId) {
    const response = await client({
        method: 'GET',
        url: baseUrl + '/user/' + userId + '/favorites'
    })
    return response.data
}

export async function saveUser (item) {
    const response = await client({
        method: 'POST',
        url: baseUrl + '/user',
        data: {
            ...item
        }
    })
    return response.data
}

export async function updateUserProfile (profileId, data) {
    const response = await client({
        method: 'PUT',
        url: baseUrl + '/user/profile/' + profileId,
        data: data
    })
    return response.data
}

export async function updateUser (item) {
    const response = await client({
        method: 'PUT',
        url: baseUrl + '/user/' + item.objectId,
        data: {
            ...item
        }
    })
    return response.data
}

export async function deleteUser (item) {
    const response = await client({
        method: 'PUT',
        url: baseUrl + '/user/' + item.objectId,
        data: {
            ...item
        }
    })
    return response.data
}

export async function loginUser (u,p) {
    const response = await client({
        method: 'POST',
        url: baseUrl + '/login',
        data: {
            username: u,
            password: p
        }
    })
    return response.data
}

export async function createUser (newUser) {
    const response = await client({
        method: 'POST',
        url: baseUrl + '/register',
        data: {
            email: newUser.email,
            username: newUser.username,
            password: newUser.password,
            verify: newUser.verify,
            test: '278'
        }
    })
    return response.data
}

export async function getMe (token) {
    const response = await client({
        method: 'POST',
        data: {
            token: token
        },
        url: baseUrl + '/me'
    })
    return response.data
}

export async function verifyEmail (email) {
    const response = await client({
        method: 'POST',
        data: {
            email: email
        },
        url: baseUrl + '/user/verifyemail'
    })
    return response.data
}

export async function verifyUser (token) {
    const response = await client({
        method: 'GET',
        url: baseUrl + '/user/verify?validate=' + token
    })
    return response.data
}

export async function changePassword ({ token, userId, password, verify }) {
    // allows authed user to change password
    const response = await client({
        method: 'POST',
        data: {
            token, 
            userId, 
            password, 
            verify
        },
        url: baseUrl + '/user/changepassword'
    })
    return response.data
}

export async function resetPassword ({ username, email }) {
    // sends reset link to user from POST
    const response = await client({
        method: 'POST',
        data: {
            email,
            username
        },
        url: baseUrl + '/user/resetpassword'
    })
    return response.data
}

export async function doResetPassword ({ token, username, new_password, confirm_new_password }) {
    // allows un-authed user to change password after reset
    const response = await client({
        method: 'POST',
        data: {
            new_password,
            confirm_new_password,
            username,
            token
        },
        url: baseUrl + '/user/doresetpassword'
    })
    return response.data
}

export async function lookupUsername (email) {
    const response = await client({
        method: 'POST',
        data: {
            email: email
        },
        url: baseUrl + '/user/lookupusername'
    })
    return response.data
}

export async function submitContact (item) {
    const response = await client({
        method: 'POST',
        url: baseUrl + '/contact',
        data: {
            ...item
        }
    })
    return response.data
}